import type { SearchPageState } from "../redux/types";
import { type SearchProductDataDTO } from "../models/SearchResultsDTO";
import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import { getSearchEndpointParams } from "~/features/search/api/fetchSearchResults";

function getApiUrl(): string {
  return occUrl("/salescampaign/search");
}

export interface SalesCampaignProductsResponseDTO {
  products?: SearchProductDataDTO[];
}

export async function fetchRecommendedProductsSearch(state: SearchPageState): Promise<SearchProductDataDTO[]> {
  const searchParams = getSearchEndpointParams(state);

  const response = await occFetch(getApiUrl() + "?" + searchParams.toString());

  if (response.redirected) {
    window.location.reload();
  }

  if (!response.ok) {
    throw new Error("failed to fetch recommendations");
  }

  return ((await response.json()) as SalesCampaignProductsResponseDTO).products ?? [];
}
